import React from "react";
import { useNavigate } from "react-router-dom";

const MnuQualy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen w-full bg-slate-950 text-white">
      <div className="mx-auto max-w-5xl px-4 py-12 sm:px-6 md:px-8">
        <div className="rounded-3xl border border-white/10 bg-slate-900/80 p-8 shadow-2xl backdrop-blur-md">
          <h1 className="mb-6 text-4xl font-extrabold text-emerald-300 md:text-5xl">
            Qualifikationen klar und verständlich zeigen
          </h1>

          <p className="mb-10 max-w-3xl text-lg text-slate-200/90">
            Experts4Europe hilft dabei, Ausbildung, Erfahrung, Sprache und Unterlagen so aufzubereiten, dass
            Arbeitgeber in Europa sie schneller verstehen und einordnen können.
          </p>

          <section className="mb-12">
            <h2 className="mb-3 text-2xl font-bold text-white md:text-3xl">Was sichtbar wird</h2>
            <ul className="list-disc space-y-4 pl-6 text-slate-200/90">
              <li><strong>Berufserfahrung:</strong> Relevante Stationen und Aufgaben werden klar strukturiert dargestellt.</li>
              <li><strong>Ausbildung:</strong> Abschlüsse und Lernwege bleiben nachvollziehbar und vergleichbar.</li>
              <li><strong>Sprache:</strong> Sprachstand und Sprachtests schaffen Vertrauen und Orientierung.</li>
              <li><strong>Unterlagen:</strong> Referenzen und Nachweise ergänzen das Profil dort, wo sie wirklich helfen.</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="mb-3 text-2xl font-bold text-white md:text-3xl">Warum das wichtig ist</h2>
            <ul className="list-disc space-y-4 pl-6 text-slate-200/90">
              <li><strong>Weniger Missverständnisse:</strong> Arbeitgeber erkennen schneller, was du wirklich kannst.</li>
              <li><strong>Mehr Sichtbarkeit:</strong> Vollständige und klare Profile werden leichter gefunden.</li>
              <li><strong>Bessere Chancen:</strong> Gute Qualifikationsdarstellung stärkt Bewerbung, Matching und Vertrauen.</li>
            </ul>
          </section>

          <div className="mt-12">
            <button
              onClick={() => navigate(-1)}
              className="rounded-xl bg-emerald-600/80 px-6 py-2 text-lg font-bold text-white shadow-xl transition duration-300 ease-in-out hover:bg-emerald-500/80"
            >
              Zurück
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MnuQualy;
